import Configuration from '../views/configuration'
import odapincodemaster from '../views/odapincodemaster/odapincodListing';
import dthhubmapping from '../views/dthhubmapping/dthhubmappingListing';
import dthtriplog from '../views/dthtriplog';
import hubmapping from '../views/hubmapping';

export default [
	{
		path: '/adminsettings/configuration',
		name: 'Configuration',
		component: Configuration,
		title: 'Configuration',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/adminsettings/odapincodemaster',
		name: 'cargomaster-odapincodemaster',
		component: odapincodemaster,
		title: 'cargomaster-odapincodemaster',
		meta: {
			requiresAuth: true
		}
	},
    {
    	path: '/adminsettings/dthhubmapping',
    	name: 'dthhubmapping',
    	component: dthhubmapping,
    	title: 'dthhubmapping',
    	meta: {
        requiresAuth: true
        }
    },
	{
    	path: '/dthtriplog',
    	name: 'dthtriplog',
    	component: dthtriplog,
    	title: 'dthtriplog',
    	meta: {
            requiresAuth: true
        }
    },
	{
    	path: '/adminsettings/hubmapping',
    	name: 'hubmapping',
    	component: hubmapping,
    	title: 'hubmapping',
    	meta: {
        requiresAuth: true
        }
    },
];



// WEBPACK FOOTER //
// ./src/modules/adminsettings/router/index.js